export const FIELDS_BY_TYPE = {
  UsersImport: [
    { key: 'phone', label: 'Phone number', required: true },
    { key: 'full_name', label: 'Full name', required: false },
    { key: 'email', label: 'Email', required: false }
  ],
  ProductsImport: [
    { key: 'product_name', label: 'Product name', required: true },
    { key: 'price_in_dollars', label: 'Price', required: true },
    { key: 'description', label: 'Description', required: false },
    { key: 'image_url', label: 'Image URL', required: false },
    { key: 'category_name', label: 'Category', required: false },
    { key: 'merchant_sku', label: 'SKU', required: false }
  ]
}

export const missingRequiredKeys = (importType, mapping) =>
  FIELDS_BY_TYPE[importType]
    .filter(field => field.required && (mapping[field.key] === null || mapping[field.key] === undefined))
    .map(field => field.label)

export const buildMatchingPayload = mapping =>
  Object.fromEntries(Object.entries(mapping).filter(([, value]) => value !== null && value !== undefined))
